import "@/lib/toastBackup";
import ScrollLockWatchdog from "@/components/common/ScrollLockWatchdog";
import ScrollMemory from "@/components/common/ScrollMemory";
import { Routes, Route, Navigate, Outlet, useLocation } from "react-router-dom";
import RightsRoute from "@/components/RightsRoute";
import "@/App.css";
import Login from "@/pages/Login";
import ByeBye from "@/pages/ByeBye";
import Activation from "@/pages/Activation";
import ZohoCallback from "@/pages/ZohoCallback";
import Dashboard from "@/pages/Dashboard";
import Tasks from "@/pages/Tasks";
import TasksTrash from "@/pages/TasksTrash";
import TaskDetail from "@/pages/TaskDetail";
import Documents from "@/pages/Documents";
import DocumentDetail from "@/pages/DocumentDetail";
import DocumentTypesAdmin from "@/pages/DocumentTypesAdmin";
import DocumentsTrash from "@/pages/DocumentsTrash";
import CRM from "@/pages/CRM";
import CrmProject from "@/pages/CrmProject";
import CrmLot from "@/pages/CrmLot";
import CrmReservations from "@/pages/CrmReservations";
import CrmQuotes from "@/pages/CrmQuotes";
import CrmSales from "@/pages/CrmSales";
import CrmDashboard from "@/pages/CrmDashboard";
import CrmContacts from "@/pages/CrmContacts";
import CrmProspects from "@/pages/CrmProspects";
import CrmContact from "@/pages/CrmContact";
import CrmPipeline from "@/pages/CrmPipeline";
import CrmOpportunity from "@/pages/CrmOpportunity";
import CrmAgenda from "@/pages/CrmAgenda";
import CrmStats from "@/pages/CrmStats";
import CrmConfig from "@/pages/CrmConfig";
import Avi from "@/pages/Avi";
import TresoAccounts from "@/pages/TresoAccounts";
import TresoAccount from "@/pages/TresoAccount";
import TresoMovements from "@/pages/TresoMovements";
import TresoConfig from "@/pages/TresoConfig";
import TresoDashboard from "@/pages/TresoDashboard";
import TresoReglements from "@/pages/TresoReglements";
import TresoEcheances from "@/pages/TresoEcheances";
import TresoOps from "@/pages/TresoOps";
import CrmMouvements from "@/pages/CrmMouvements";
import Pointage from "@/pages/Pointage";
import Settings from "@/pages/Settings";
import AppLayout from "@/components/AppLayout";
import ProtectedRoute from "@/components/ProtectedRoute";
import { useAuth } from "@/context/AuthContext";
import UpdateNotifier from "@/components/common/UpdateNotifier";
import ReloadConfirm from "@/components/common/ReloadConfirm";
import DeskLeaveDialog from "@/components/common/DeskLeaveDialog";
import DbOutageBanner from "@/components/DbOutageBanner";

function RootRedirect() {
  const { user, loading } = useAuth();
  if (loading) return null;
  return <Navigate to={user ? "/tableau-de-bord" : "/connexion"} replace />;
}

/** iter381 pt 1 — « Règlements » renommé « Encaissements » : l'ancienne adresse redirige (paramètres conservés). */
function RedirectReglements() { const { search } = useLocation(); return <Navigate to={`/tresorerie/encaissements${search}`} replace />; }

export default function App() {
  return (
    <div className="App">
      <UpdateNotifier />
      <ReloadConfirm />
      <DeskLeaveDialog />
      <DbOutageBanner />
      <ScrollLockWatchdog />
      <ScrollMemory />
      <Routes>
        <Route path="/" element={<RootRedirect />} />
        <Route path="/connexion" element={<Login />} />
        <Route path="/bye-bye" element={<ByeBye />} />
        <Route path="/activation" element={<Activation />} />
        <Route path="/zoho/callback" element={<ZohoCallback />} />

        <Route element={<ProtectedRoute><AppLayout /></ProtectedRoute>}>
          <Route path="/tableau-de-bord" element={<Dashboard />} />
          <Route element={<RightsRoute right="tasks.view"><Outlet /></RightsRoute>}>
            <Route path="/taches" element={<Tasks />} />
            <Route path="/taches/corbeille" element={<TasksTrash />} />
            <Route path="/taches/:id" element={<TaskDetail />} />
          </Route>
          <Route element={<RightsRoute right="documents.view"><Outlet /></RightsRoute>}>
            <Route path="/documents" element={<Documents />} />
            <Route path="/documents/corbeille" element={<DocumentsTrash />} />
            <Route path="/documents/types" element={<RightsRoute right="documents.manage_types"><DocumentTypesAdmin /></RightsRoute>} />
            <Route path="/documents/:id" element={<RightsRoute right="documents.read"><DocumentDetail /></RightsRoute>} />
          </Route>
          <Route element={<RightsRoute right="crm.view"><Outlet /></RightsRoute>}>
            <Route path="/crm" element={<CRM />} />
            <Route path="/crm/projets/:id" element={<CrmProject />} />
            <Route path="/crm/lots/:id" element={<CrmLot />} />
            <Route path="/crm/devis" element={<CrmQuotes />} />
            <Route path="/crm/reservations" element={<CrmReservations />} />
            <Route path="/crm/ventes" element={<CrmSales />} />
            <Route path="/crm/mouvements" element={<CrmMouvements />} />
            <Route path="/crm/contacts" element={<CrmContacts />} />
            <Route path="/crm/prospects" element={<CrmProspects />} />
            <Route path="/crm/contacts/:id" element={<CrmContact />} />
            <Route path="/crm/pipeline" element={<CrmPipeline />} />
            <Route path="/crm/opportunites/:id" element={<CrmOpportunity />} />
            <Route path="/crm/agenda" element={<CrmAgenda />} />
            <Route path="/crm/statistiques" element={<CrmStats />} />
            <Route path="/crm/tableau-de-bord" element={<CrmDashboard />} />
            <Route path="/crm/configuration" element={<CrmConfig />} />
          </Route>
          <Route element={<RightsRoute right="tresorerie.view"><Outlet /></RightsRoute>}>
            <Route path="/tresorerie" element={<TresoDashboard />} />
            <Route path="/tresorerie/comptes" element={<TresoAccounts />} />
            <Route path="/tresorerie/comptes/:id" element={<TresoAccount />} />
            <Route path="/tresorerie/mouvements" element={<TresoMovements />} />
            <Route path="/tresorerie/encaissements" element={<TresoReglements />} />
            <Route path="/tresorerie/reglements" element={<RedirectReglements />} />
            <Route path="/tresorerie/echeances" element={<TresoEcheances />} />
            <Route path="/tresorerie/decaissements" element={<TresoOps op="decaissement" />} />
            <Route path="/tresorerie/alimentations" element={<TresoOps op="alimentation" />} />
            <Route path="/tresorerie/transferts" element={<TresoOps op="transfert" />} />
            <Route path="/tresorerie/retraits" element={<TresoOps op="retrait" />} />
            <Route path="/tresorerie/etats" element={<Navigate to="/tresorerie/mouvements" replace />} />
            <Route path="/tresorerie/configuration" element={<RightsRoute right="tresorerie.configure"><TresoConfig /></RightsRoute>} />
          </Route>
          <Route element={<RightsRoute right="avi.view"><Outlet /></RightsRoute>}>
            <Route path="/avi" element={<Avi />} />
            <Route path="/avi/:id" element={<Avi />} />
          </Route>
          <Route path="/pointage" element={<RightsRoute right="pointage.view"><Pointage /></RightsRoute>} />
          <Route path="/parametres" element={<Settings />} />
        </Route>

        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </div>
  );
}
